import { TicketStatus } from "../types";

export const mockTicketDetailsRootUrl = "/console/tickets";

export const mockTicketHistoryResponse = {
  success: true,
  data: {
    count: 7,
    results: [
      {
        id: 476930,
        subject: "Test ticket",
        createdAt: "2021-11-11T21:19:21Z",
        updatedAt: "2021-11-12T01:35:25Z",
        status: TicketStatus.open,
        priority: "p3_general_issue",
        product: { name: "API", value: "product_api" },
      },
      {
        id: 438023,
        subject: "Chat Question from hhartigan@twilio.com",
        createdAt: "2021-07-29T14:29:30Z",
        updatedAt: "2021-07-29T14:37:39Z",
        status: TicketStatus.closed,
        priority: "p3_general_issue",
        product: { name: "API", value: "product_api" },
      },
      {
        id: 419935,
        subject: "Chat #419935: Test 123",
        createdAt: "2021-04-21T15:37:04Z",
        updatedAt: "2021-04-25T16:01:06Z",
        status: TicketStatus.hold,
        priority: "p3_general_issue",
        product: { name: "API", value: "product_api" },
      },
      {
        id: 367085,
        subject: "Test",
        createdAt: "2020-10-08T16:27:16Z",
        updatedAt: "2020-10-08T16:27:16Z",
        status: TicketStatus.new,
        priority: "p3_general_issue",
        product: {
          name: "Account Administration",
          value: "prod_account_admin",
        },
      },
      {
        id: 359459,
        subject: "Hugh Test",
        createdAt: "2020-09-21T21:56:07Z",
        updatedAt: "2020-09-25T22:01:58Z",
        status: TicketStatus.pending,
        priority: "p3_general_issue",
        product: { name: "Voice - TwiML", value: "product_voice_twiml" },
      },
      {
        id: 350681,
        subject: "Chat Question from hhartigan@twilio.com",
        createdAt: "2020-09-02T18:22:53Z",
        updatedAt: "2020-09-02T18:23:20Z",
        status: TicketStatus.solved,
        priority: "p3_general_issue",
        product: { name: "API", value: "product_api" },
      },
      {
        id: 342626,
        subject: "Chat #342626: I need help with messaging!",
        createdAt: "2020-08-13T20:06:16Z",
        updatedAt: "2020-08-17T21:01:57Z",
        status: TicketStatus.closed,
        priority: "p3_general_issue",
        product: { name: "Marketing", value: "dept_marketing" },
      },
    ],
  },
};

export const mockTicketHistoryPermissionsDisabled = {
  canViewAccountLevelTicketHistory: false,
};

export const mockTicketHistoryPermissionsEnabled = {
  canViewAccountLevelTicketHistory: true,
};
